import { useState } from "react";
import { Globe } from "lucide-react";
import { cn } from "@/utils/helpers";

/* Monochrome platform marks for the two hosts a favicon service renders
   poorly at this size. Inline brand SVGs in currentColor. */
function TikTokMark() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M16.5 3c.3 2 1.5 3.4 3.5 3.6v2.3c-1.2.1-2.4-.2-3.5-.8v5.6c0 3.5-2.6 5.8-5.6 5.3-2.5-.4-4.2-2.5-4.2-5 0-2.9 2.6-5.2 5.6-4.7v2.4c-.4-.1-.8-.2-1.2-.2-1.4 0-2.4 1.1-2.3 2.5.1 1.2 1.1 2.1 2.3 2.1 1.4 0 2.4-1 2.4-2.5V3h3z" />
    </svg>
  );
}

function InstagramMark() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" stroke="none" />
    </svg>
  );
}

/**
 * The mark for one source host, 13px by default: the TikTok and Instagram
 * glyphs for their own hosts, the site's favicon for anything else, and a Globe
 * when there is no host or the favicon will not load.
 */
export default function SourceFavicon({
  host,
  size = 13,
  className,
}: {
  host: string | null;
  size?: number;
  className?: string;
}) {
  const [failedHost, setFailedHost] = useState<string | null>(null);
  const h = host?.toLowerCase() ?? "";
  const box = { width: size, height: size };

  if (h.includes("tiktok")) {
    return (
      <span className={cn("sig-favicon", className)} style={box}>
        <TikTokMark />
      </span>
    );
  }
  if (h.includes("instagram")) {
    return (
      <span className={cn("sig-favicon", className)} style={box}>
        <InstagramMark />
      </span>
    );
  }
  if (!host || failedHost === host) {
    return (
      <span className={cn("sig-favicon", className)} style={box}>
        <Globe aria-hidden="true" strokeWidth={1.9} />
      </span>
    );
  }
  return (
    <span className={cn("sig-favicon", className)} style={box}>
      <img
        src={`https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=32`}
        alt=""
        loading="lazy"
        width={size}
        height={size}
        onError={() => setFailedHost(host)}
      />
    </span>
  );
}
